// import DriveScout from '@drivescout/drivescout-vue/src/assets/js/index'

jQuery(document).ready(function($){

    if (jQuery('#drivescout-app')) {
        const drivescout = require('@drivescout/drivescout-vue/src/assets/js/index');
    }

});